module.exports = __webpack_public_path__ + "static/img/123.82ac9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/123.png
// module id = VjIu
// module chunks = 1